import LoginForm from "./loginForm";
import CustomCard from "./Card";

export default function SignIn() {
  return (
    <CustomCard
      title={"به سامانه اردو جهادی اثر خوش آمدید !"}
      subTitle={
        "برای ورود به حساب، لطفا نام کاربری و رمزعبور خود را وارد کنید."
      }
    >
      <LoginForm />
    </CustomCard>
  );
}
